import { render } from "./MailRenderPrinter.vue?vue&type=template&id=6ce5cc58&scoped=true"
import script from "./MailRenderPrinter.vue?vue&type=script&lang=js"
export * from "./MailRenderPrinter.vue?vue&type=script&lang=js"

import "./MailRenderPrinter.vue?vue&type=style&index=0&id=6ce5cc58&scoped=true&lang=scss"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce5cc58"]])

export default __exports__